import { render, staticRenderFns } from "./DetailGadaiKomp.vue?vue&type=template&id=c5c8957c&scoped=true&"
import script from "./DetailGadaiKomp.vue?vue&type=script&lang=js&"
export * from "./DetailGadaiKomp.vue?vue&type=script&lang=js&"
import style0 from "./DetailGadaiKomp.vue?vue&type=style&index=0&id=c5c8957c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c8957c",
  null
  
)

export default component.exports